// https://stackoverflow.com/a/63961972
/* eslint-disable no-shadow */

export enum ASSESSMENT_TYPE {
  DEX = 'dex',
  CASE_STUDY = 'caseStudy',
  PRESENTATION = 'presentation',
  TCC = 'tcc',
}

export enum ASSESSMENT_RESULT_STATUS {
  NONE = 'none',
  PASSED = 'passed',
  FAILED = 'failed',
  WAITING_GRADING = 'waitingGrading',
  TCC_THEME_PENDING_APPROVAL = 'TCCThemePendingApproval',
  TCC_THEME_APPROVED = 'TCCThemeApproved',
  TCC_THEME_REJECTED = 'TCCThemeRejected',
  PARTIAL_TCC_PENDING_REVIEW = 'partialTCCPendingReview',
  PARTIAL_TCC_APPROVED = 'partialTCCApproved',
  PARTIAL_TCC_REJECTED = 'partialTCCRejected',
  FAILED_ELEGIBLE_FOR_REVALUATION = 'failedEligibleForRevaluation',
  WAITING_REVALUATION = 'waitingRevaluation',
}

export enum ASSESSMENT_STATUS {
  PASSED = 'passed',
  RETRY = 'retry',
  AVAILABLE = 'available',
  UNAVAILABLE = 'unavailable',
  WAITING_GRADING = 'waiting_grading',
  TCC_IN_PROGRESS = 'tccInProgress',
}

export enum REPLY_TYPE {
  TCC_THEME = 'TCCTheme',
  PARTIAL_TCC = 'partialTCC',
  FINAL_TCC = 'finalTCC',
  TCC_REVALUATION = 'TCCRevaluation',
  STUDY_CASE = 'studyCase',
  PRESENTATION = 'presentation',
  NONE = 'none',
}

export enum REPLY_STATUS {
  PENDING = 'pending',
  REVIEWED = 'reviewed',
  APPROVED = 'approved',
  REJECTED = 'rejected',
  NONE = 'none',
}

export interface EvaluationSheet {
  clarityGrade: number;
  contentGrade: number;
  discourseGrade: number;
  structureGrade: number;
  innovationGrade: number;
  formatRulesGrade: number;
  originalityGrade: number;
  upToDatenessGrade: number;
  solutionGrade: number;
  adherenceGrade: number;
  presentationGrade: number;
  problematizationGrade: number;
  contextualizationGrade: number;
  isPlagiarism: boolean;
}

export interface Reply {
  type: REPLY_TYPE;
  status: REPLY_STATUS;
  answer?: string;
  feedbackText?: string;
  link?: string;
  feedbackLink?: string;
}

export interface AssessmentResult {
  id: number;
  grade: number;
  createdAt: Date;
  gradingDate: Date;
  evaluationSheet: EvaluationSheet;
  status: ASSESSMENT_RESULT_STATUS;
  lastReply: Reply;
  replies: Reply[];
  maxPartialTCCSubmissions: number;
}

export interface Variant {
  dexExamGroupId: number;
  title: string;
  link: string;
  id: number;
}

export interface DexExamGroup {
  totalDuration: number;
  totalQuestions: number;
}

export interface Category {
  name: string;
}

export interface RelatedAssessment {
  isAvailable: boolean;
}

export interface Assessment {
  id: number;
  title: string;
  category: Category;
  daysToRetry: number;
  assessmentType: ASSESSMENT_TYPE;
  passingGradePercentage: number;
  assessmentStatusByUser: ASSESSMENT_STATUS;
  minimumContractDays: number;
  daysUntilAvailable: number;
  assessmentResultsByUser: AssessmentResult[];
  currentVariantByUser: Variant;
  dexExamGroup: DexExamGroup;
  currentRelatedCourse: RelatedAssessment;
  instructions: string;
}
